import React, { useRef } from 'react';
import { Editor as TinyMCE } from '@tinymce/tinymce-react';

export const Editor = (props: any) => {
  const editorRef = useRef(null);
  return (
    <TinyMCE
      tinymceScriptSrc={'/tinymce/tinymce.min.js'}
      licenseKey="gpl"
      onInit={(_evt, editor) => (editorRef.current = editor as any)}
      {...props}
    />
  );
};
